import { Button } from "@mui/material"
import FoodApi from "../data/FoodApi"
import useLogin from "../libs/login/useLogin"
import { LogoutOutlined } from "@mui/icons-material"
import LoginButton from "./LoginButton"

function Profile(){
    const {logout} = useLogin()
    return <div className="keyval">
        <label>Name</label>
        <div>{FoodApi.i.name}</div>
            <Button variant="outlined" onClick={logout} startIcon={<LogoutOutlined/>}>Logout</Button> :
    </div>
}
export default function Settings(){
    const {isLoggedIn} = useLogin()
    return <div id="settings">
        {isLoggedIn ? <Profile/> : <LoginButton/>}
    </div>
}